// File: src/EnglishTool/sentencePool.js

/**
 * getSentencePool(grade)
 * Returns an array of sentence objects for the given grade level,
 * each with { sentence, focus, correctAnswers }.
 *
 * For example:
 * {
 *   sentence: "The cat sleeps on the mat.",
 *   focus: "nouns",
 *   correctAnswers: ["cat", "mat"]
 * }
 */
export function getSentencePool(grade) {
    const data = {
      1: [
  {
    sentence: "The cat sleeps on the mat.",
    focus: "nouns",
    correctAnswers: ["cat", "mat"],
  },
  {
    sentence: "He runs fast.",
    focus: "verbs",
    correctAnswers: ["runs"],
  },
  {
    sentence: "That is a big red ball.",
    focus: "adjectives",
    correctAnswers: ["big", "red"],
  },
  {
    sentence: "She quickly jumped.",
    focus: "adverbs",
    correctAnswers: ["quickly"],
  },
  {
    sentence: "We love apples.",
    focus: "nouns",
    correctAnswers: ["apples"],
  },
  {
    sentence: "The sun is yellow.",
    focus: "adjectives",
    correctAnswers: ["yellow"],
  },
  {
    sentence: "Dogs bark loudly.",
    focus: "adverbs",
    correctAnswers: ["loudly"],
  },
  {
    sentence: "My dad reads a book.",
    focus: "nouns",
    correctAnswers: ["dad", "book"],
  },
  {
    sentence: "The rabbit hops.",
    focus: "verbs",
    correctAnswers: ["hops"],
  },
  {
    sentence: "It is a small fish.",
    focus: "adjectives",
    correctAnswers: ["small"],
  },
  {
    sentence: "The girl sings softly.",
    focus: "adverbs",
    correctAnswers: ["softly"],
  },
  {
    sentence: "We see a blue car.",
    focus: "adjectives",
    correctAnswers: ["blue"],
  },
  {
    sentence: "The bird flies high.",
    focus: "adverbs",
    correctAnswers: ["high"],
  },
  {
    sentence: "I have a red pen.",
    focus: "adjectives",
    correctAnswers: ["red"],
  },
  {
    sentence: "Boys play outside.",
    focus: "verbs",
    correctAnswers: ["play"],
  },
  {
    sentence: "The apple tastes sweet.",
    focus: "adjectives",
    correctAnswers: ["sweet"],
  },
  {
    sentence: "She walks slowly.",
    focus: "adverbs",
    correctAnswers: ["slowly"],
  },
  {
    sentence: "My mom cooks food.",
    focus: "nouns",
    correctAnswers: ["mom", "food"],
  },
  {
    sentence: "He draws a house.",
    focus: "verbs",
    correctAnswers: ["draws"],
  },
  {
    sentence: "The baby laughs happily.",
    focus: "adverbs",
    correctAnswers: ["happily"],
  },
],

      2: [
  {
    sentence: "My friend rides a bike every morning.",
    focus: "verbs",
    correctAnswers: ["rides"],
  },
  {
    sentence: "The child found a shiny coin.",
    focus: "adjectives",
    correctAnswers: ["shiny"],
  },
  {
    sentence: "We carefully painted the fence.",
    focus: "adverbs",
    correctAnswers: ["carefully"],
  },
  {
    sentence: "They saw many stars in the sky.",
    focus: "nouns",
    correctAnswers: ["stars", "sky"],
  },
  {
    sentence: "Dad drives us to school.",
    focus: "verbs",
    correctAnswers: ["drives"],
  },
  {
    sentence: "She wore a beautiful dress.",
    focus: "adjectives",
    correctAnswers: ["beautiful"],
  },
  {
    sentence: "The birds sing sweetly.",
    focus: "adverbs",
    correctAnswers: ["sweetly"],
  },
  {
    sentence: "We read stories at night.",
    focus: "verbs",
    correctAnswers: ["read"],
  },
  {
    sentence: "Tom kicked the soccer ball.",
    focus: "nouns",
    correctAnswers: ["Tom", "soccer", "ball"],
  },
  {
    sentence: "The puppy barked loudly.",
    focus: "adverbs",
    correctAnswers: ["loudly"],
  },
  {
    sentence: "Her pencil is sharp.",
    focus: "adjectives",
    correctAnswers: ["sharp"],
  },
  {
    sentence: "We walked along the river.",
    focus: "nouns",
    correctAnswers: ["river"],
  },
  {
    sentence: "The cake tasted delicious.",
    focus: "adjectives",
    correctAnswers: ["delicious"],
  },
  {
    sentence: "She skipped happily to class.",
    focus: "adverbs",
    correctAnswers: ["happily"],
  },
  {
    sentence: "He quickly answered the question.",
    focus: "adverbs",
    correctAnswers: ["quickly"],
  },
  {
    sentence: "Our teacher smiled kindly.",
    focus: "adverbs",
    correctAnswers: ["kindly"],
  },
  {
    sentence: "I found a blue feather.",
    focus: "adjectives",
    correctAnswers: ["blue"],
  },
  {
    sentence: "The rabbit hopped across the field.",
    focus: "verbs",
    correctAnswers: ["hopped"],
  },
  {
    sentence: "Children played games outside.",
    focus: "nouns",
    correctAnswers: ["Children", "games"],
  },
  {
    sentence: "Grandma told an interesting story.",
    focus: "adjectives",
    correctAnswers: ["interesting"],
  },
],

      3: [
  {
    sentence: "Students enjoy reading interesting books.",
    focus: "adjectives",
    correctAnswers: ["interesting"],
  },
  {
    sentence: "The children carefully painted their pictures.",
    focus: "adverbs",
    correctAnswers: ["carefully"],
  },
  {
    sentence: "My sister loves to bake cookies on weekends.",
    focus: "verbs",
    correctAnswers: ["loves", "bake"],
  },
  {
    sentence: "He practiced the piano for an hour.",
    focus: "nouns",
    correctAnswers: ["piano", "hour"],
  },
  {
    sentence: "She quickly wrote a story about her day.",
    focus: "adverbs",
    correctAnswers: ["quickly"],
  },
  {
    sentence: "The tall boy jumped over the fence.",
    focus: "adjectives",
    correctAnswers: ["tall"],
  },
  {
    sentence: "We finished our homework early.",
    focus: "adverbs",
    correctAnswers: ["early"],
  },
  {
    sentence: "They visited the science museum.",
    focus: "nouns",
    correctAnswers: ["museum"],
  },
  {
    sentence: "The team played together and won.",
    focus: "verbs",
    correctAnswers: ["played", "won"],
  },
  {
    sentence: "She wore her favorite yellow dress.",
    focus: "adjectives",
    correctAnswers: ["favorite", "yellow"],
  },
  {
    sentence: "Mom patiently helped me solve the puzzle.",
    focus: "adverbs",
    correctAnswers: ["patiently"],
  },
  {
    sentence: "We celebrated his birthday last Friday.",
    focus: "nouns",
    correctAnswers: ["birthday", "Friday"],
  },
  {
    sentence: "The chef carefully decorated the cake.",
    focus: "adverbs",
    correctAnswers: ["carefully"],
  },
  {
    sentence: "He shouted loudly at the concert.",
    focus: "adverbs",
    correctAnswers: ["loudly"],
  },
  {
    sentence: "Sarah received a special award for kindness.",
    focus: "adjectives",
    correctAnswers: ["special"],
  },
  {
    sentence: "The dog barked at the stranger.",
    focus: "verbs",
    correctAnswers: ["barked"],
  },
  {
    sentence: "The playground was empty after school.",
    focus: "adjectives",
    correctAnswers: ["empty"],
  },
  {
    sentence: "Grandpa tells funny stories at dinner.",
    focus: "adjectives",
    correctAnswers: ["funny"],
  },
  {
    sentence: "Our class will visit the library tomorrow.",
    focus: "nouns",
    correctAnswers: ["class", "library"],
  },
  {
    sentence: "He always answers the questions politely.",
    focus: "adverbs",
    correctAnswers: ["politely"],
  },
],

      4: [
  {
    sentence: "My teacher explained the project thoroughly.",
    focus: "adverbs",
    correctAnswers: ["thoroughly"],
  },
  {
    sentence: "They eagerly awaited the final results.",
    focus: "adverbs",
    correctAnswers: ["eagerly"],
  },
  {
    sentence: "We discovered fossils during our field trip.",
    focus: "nouns",
    correctAnswers: ["fossils", "trip"],
  },
  {
    sentence: "Her grandparents traveled across the country.",
    focus: "verbs",
    correctAnswers: ["traveled"],
  },
  {
    sentence: "The athletes train daily to improve performance.",
    focus: "verbs",
    correctAnswers: ["train", "improve"],
  },
  {
    sentence: "The mountain air was crisp and cold.",
    focus: "adjectives",
    correctAnswers: ["crisp", "cold"],
  },
  {
    sentence: "Scientists carefully recorded the data.",
    focus: "adverbs",
    correctAnswers: ["carefully"],
  },
  {
    sentence: "Our team celebrated the exciting victory.",
    focus: "adjectives",
    correctAnswers: ["exciting"],
  },
  {
    sentence: "She completed the assignment successfully.",
    focus: "adverbs",
    correctAnswers: ["successfully"],
  },
  {
    sentence: "The students organized a charity event.",
    focus: "verbs",
    correctAnswers: ["organized"],
  },
  {
    sentence: "Their invention won first place in the competition.",
    focus: "nouns",
    correctAnswers: ["invention", "competition"],
  },
  {
    sentence: "He quickly solved the difficult problem.",
    focus: "adverbs",
    correctAnswers: ["quickly"],
  },
  {
    sentence: "We built a sturdy bridge over the river.",
    focus: "adjectives",
    correctAnswers: ["sturdy"],
  },
  {
    sentence: "She painted a beautiful picture for her friend.",
    focus: "adjectives",
    correctAnswers: ["beautiful"],
  },
  {
    sentence: "The orchestra performed skillfully on stage.",
    focus: "adverbs",
    correctAnswers: ["skillfully"],
  },
  {
    sentence: "The museum displayed rare dinosaur bones.",
    focus: "nouns",
    correctAnswers: ["museum", "bones"],
  },
  {
    sentence: "He jogged along the quiet road every morning.",
    focus: "adjectives",
    correctAnswers: ["quiet"],
  },
  {
    sentence: "The reporter interviewed the mayor yesterday.",
    focus: "verbs",
    correctAnswers: ["interviewed"],
  },
  {
    sentence: "Her response was honest and thoughtful.",
    focus: "adjectives",
    correctAnswers: ["honest", "thoughtful"],
  },
  {
    sentence: "The puppy barked excitedly at the squirrel.",
    focus: "adverbs",
    correctAnswers: ["excitedly"],
  },
],

      5: [
  {
    sentence: "The class debated the pros and cons of recycling.",
    focus: "verbs",
    correctAnswers: ["debated"],
  },
  {
    sentence: "Scientists examine weather patterns to predict storms.",
    focus: "nouns",
    correctAnswers: ["scientists", "weather", "patterns", "storms"],
  },
  {
    sentence: "His cousin enthusiastically joined the robotics club.",
    focus: "adverbs",
    correctAnswers: ["enthusiastically"],
  },
  {
    sentence: "She meticulously organized her art supplies.",
    focus: "adverbs",
    correctAnswers: ["meticulously"],
  },
  {
    sentence: "The committee chose to extend the registration deadline.",
    focus: "verbs",
    correctAnswers: ["chose", "extend"],
  },
  {
    sentence: "The engineer designed a complex bridge.",
    focus: "adjectives",
    correctAnswers: ["complex"],
  },
  {
    sentence: "Her response was unexpectedly cheerful.",
    focus: "adverbs",
    correctAnswers: ["unexpectedly"],
  },
  {
    sentence: "We visited several famous landmarks on our trip.",
    focus: "adjectives",
    correctAnswers: ["famous"],
  },
  {
    sentence: "The explorer documented rare species in the rainforest.",
    focus: "verbs",
    correctAnswers: ["documented"],
  },
  {
    sentence: "My uncle generously donated books to the library.",
    focus: "adverbs",
    correctAnswers: ["generously"],
  },
  {
    sentence: "The presentation included colorful graphs and charts.",
    focus: "adjectives",
    correctAnswers: ["colorful"],
  },
  {
    sentence: "They observed a rapid increase in temperature.",
    focus: "adjectives",
    correctAnswers: ["rapid"],
  },
  {
    sentence: "Our principal enthusiastically greeted everyone.",
    focus: "adverbs",
    correctAnswers: ["enthusiastically"],
  },
  {
    sentence: "She researched the topic thoroughly before writing.",
    focus: "adverbs",
    correctAnswers: ["thoroughly"],
  },
  {
    sentence: "The archaeologist unearthed ancient artifacts.",
    focus: "nouns",
    correctAnswers: ["archaeologist", "artifacts"],
  },
  {
    sentence: "Students participated in the annual science fair.",
    focus: "nouns",
    correctAnswers: ["students", "science", "fair"],
  },
  {
    sentence: "He composed an original melody for the concert.",
    focus: "verbs",
    correctAnswers: ["composed"],
  },
  {
    sentence: "The museum displayed fascinating exhibits.",
    focus: "adjectives",
    correctAnswers: ["fascinating"],
  },
  {
    sentence: "The weather became unusually cold overnight.",
    focus: "adverbs",
    correctAnswers: ["unusually"],
  },
  {
    sentence: "She gradually improved her math skills.",
    focus: "adverbs",
    correctAnswers: ["gradually"],
  },
],

      6: [
  {
    sentence: "He frequently volunteers at the local animal shelter.",
    focus: "adverbs",
    correctAnswers: ["frequently"],
  },
  {
    sentence: "The new invention drastically reduced energy consumption.",
    focus: "adverbs",
    correctAnswers: ["drastically"],
  },
  {
    sentence: "Teachers encouraged students to investigate sources.",
    focus: "verbs",
    correctAnswers: ["encouraged", "investigate"],
  },
  {
    sentence: "She recited the poem flawlessly on stage.",
    focus: "adverbs",
    correctAnswers: ["flawlessly"],
  },
  {
    sentence: "Urbanization is changing the landscape of many regions.",
    focus: "verbs",
    correctAnswers: ["is", "changing"],
  },
  {
    sentence: "The hikers carefully navigated the rocky terrain.",
    focus: "adverbs",
    correctAnswers: ["carefully"],
  },
  {
    sentence: "The scientist presented a groundbreaking discovery.",
    focus: "adjectives",
    correctAnswers: ["groundbreaking"],
  },
  {
    sentence: "They collaboratively developed a new strategy.",
    focus: "adverbs",
    correctAnswers: ["collaboratively"],
  },
  {
    sentence: "Global warming affects ecosystems worldwide.",
    focus: "verbs",
    correctAnswers: ["affects"],
  },
  {
    sentence: "The researcher meticulously recorded the results.",
    focus: "adverbs",
    correctAnswers: ["meticulously"],
  },
  {
    sentence: "She was awarded a prestigious scholarship.",
    focus: "adjectives",
    correctAnswers: ["prestigious"],
  },
  {
    sentence: "The essay was written thoughtfully and clearly.",
    focus: "adverbs",
    correctAnswers: ["thoughtfully", "clearly"],
  },
  {
    sentence: "Students analyzed primary and secondary sources.",
    focus: "verbs",
    correctAnswers: ["analyzed"],
  },
  {
    sentence: "The athlete trained rigorously for the competition.",
    focus: "adverbs",
    correctAnswers: ["rigorously"],
  },
  {
    sentence: "Biodiversity helps maintain ecosystem balance.",
    focus: "nouns",
    correctAnswers: ["biodiversity", "ecosystem", "balance"],
  },
  {
    sentence: "The city launched a recycling initiative.",
    focus: "verbs",
    correctAnswers: ["launched"],
  },
  {
    sentence: "My cousin speaks three different languages fluently.",
    focus: "adverbs",
    correctAnswers: ["fluently"],
  },
  {
    sentence: "The storm caused extensive damage.",
    focus: "adjectives",
    correctAnswers: ["extensive"],
  },
  {
    sentence: "The author described the setting vividly.",
    focus: "adverbs",
    correctAnswers: ["vividly"],
  },
  {
    sentence: "They debated the advantages of renewable energy.",
    focus: "nouns",
    correctAnswers: ["advantages", "energy"],
  },
],

      7: [
  {
    sentence: "He attempted to articulate his thoughts clearly.",
    focus: "adverbs",
    correctAnswers: ["clearly"],
  },
  {
    sentence: "Government officials proposed a new plan for transport.",
    focus: "verbs",
    correctAnswers: ["proposed"],
  },
  {
    sentence: "Environmental activists strive to protect species.",
    focus: "verbs",
    correctAnswers: ["strive", "protect"],
  },
  {
    sentence: "The novelist described the setting in vivid detail.",
    focus: "adjectives",
    correctAnswers: ["vivid"],
  },
  {
    sentence: "Students often underestimate the importance of rest.",
    focus: "adverbs",
    correctAnswers: ["often"],
  },
  {
    sentence: "The organization implemented several innovative strategies.",
    focus: "adjectives",
    correctAnswers: ["innovative"],
  },
  {
    sentence: "Participants eagerly engaged in the debate.",
    focus: "adverbs",
    correctAnswers: ["eagerly"],
  },
  {
    sentence: "The architect designed an environmentally friendly building.",
    focus: "adjectives",
    correctAnswers: ["environmentally", "friendly"],
  },
  {
    sentence: "She successfully defended her research findings.",
    focus: "adverbs",
    correctAnswers: ["successfully"],
  },
  {
    sentence: "The artist skillfully blended colors on the canvas.",
    focus: "adverbs",
    correctAnswers: ["skillfully"],
  },
  {
    sentence: "The scientist hypothesized about climate change.",
    focus: "verbs",
    correctAnswers: ["hypothesized"],
  },
  {
    sentence: "A sudden storm disrupted outdoor activities.",
    focus: "adjectives",
    correctAnswers: ["sudden", "outdoor"],
  },
  {
    sentence: "The committee announced the results yesterday.",
    focus: "verbs",
    correctAnswers: ["announced"],
  },
  {
    sentence: "The director carefully reviewed each application.",
    focus: "adverbs",
    correctAnswers: ["carefully"],
  },
  {
    sentence: "Her essay included several persuasive arguments.",
    focus: "adjectives",
    correctAnswers: ["persuasive"],
  },
  {
    sentence: "The engineer constructed the bridge efficiently.",
    focus: "adverbs",
    correctAnswers: ["efficiently"],
  },
  {
    sentence: "The journalist investigated various sources for accuracy.",
    focus: "verbs",
    correctAnswers: ["investigated"],
  },
  {
    sentence: "She wore a distinctive patterned scarf.",
    focus: "adjectives",
    correctAnswers: ["distinctive", "patterned"],
  },
  {
    sentence: "The invention revolutionized the way people communicate.",
    focus: "verbs",
    correctAnswers: ["revolutionized", "communicate"],
  },
  {
    sentence: "The teacher frequently encourages class participation.",
    focus: "adverbs",
    correctAnswers: ["frequently"],
  },
],

      8: [
  {
    sentence: "The collaborative project required significant research.",
    focus: "adjectives",
    correctAnswers: ["collaborative", "significant"],
  },
  {
    sentence: "Philosophers debate timeless questions about human nature.",
    focus: "adjectives",
    correctAnswers: ["timeless", "human"],
  },
  {
    sentence: "She confronted her fears by performing on stage.",
    focus: "verbs",
    correctAnswers: ["confronted", "performing"],
  },
  {
    sentence: "Volunteers coordinated a charity drive for the homeless.",
    focus: "verbs",
    correctAnswers: ["coordinated"],
  },
  {
    sentence: "Our community fosters strong relationships.",
    focus: "adjectives",
    correctAnswers: ["strong"],
  },
  {
    sentence: "Scientists meticulously documented their observations.",
    focus: "adverbs",
    correctAnswers: ["meticulously"],
  },
  {
    sentence: "He skeptically reviewed the proposed solution.",
    focus: "adverbs",
    correctAnswers: ["skeptically"],
  },
  {
    sentence: "Environmental policies impact global economies.",
    focus: "verbs",
    correctAnswers: ["impact"],
  },
  {
    sentence: "The analysis included complex mathematical formulas.",
    focus: "adjectives",
    correctAnswers: ["complex", "mathematical"],
  },
  {
    sentence: "Authors often express abstract ideas through metaphor.",
    focus: "adjectives",
    correctAnswers: ["abstract"],
  },
  {
    sentence: "Innovators constantly seek creative approaches.",
    focus: "adverbs",
    correctAnswers: ["constantly"],
  },
  {
    sentence: "She synthesized information from various sources.",
    focus: "verbs",
    correctAnswers: ["synthesized"],
  },
  {
    sentence: "The historian examined primary documents carefully.",
    focus: "adverbs",
    correctAnswers: ["carefully"],
  },
  {
    sentence: "Their performance demonstrated exceptional skill.",
    focus: "adjectives",
    correctAnswers: ["exceptional"],
  },
  {
    sentence: "He articulated his perspective confidently.",
    focus: "adverbs",
    correctAnswers: ["confidently"],
  },
  {
    sentence: "The presentation featured relevant visual aids.",
    focus: "adjectives",
    correctAnswers: ["relevant", "visual"],
  },
  {
    sentence: "She interpreted the data accurately.",
    focus: "adverbs",
    correctAnswers: ["accurately"],
  },
  {
    sentence: "They advocated for equal opportunities.",
    focus: "verbs",
    correctAnswers: ["advocated"],
  },
  {
    sentence: "The scientist observed subtle changes over time.",
    focus: "adjectives",
    correctAnswers: ["subtle"],
  },
  {
    sentence: "The participants enthusiastically supported the initiative.",
    focus: "adverbs",
    correctAnswers: ["enthusiastically"],
  },
],

      9: [
  {
    sentence: "Historians analyze past events for better understanding.",
    focus: "verbs",
    correctAnswers: ["analyze"],
  },
  {
    sentence: "Her leadership style effectively motivated the team.",
    focus: "adverbs",
    correctAnswers: ["effectively"],
  },
  {
    sentence: "Technological innovations have accelerated interactions.",
    focus: "verbs",
    correctAnswers: ["have", "accelerated"],
  },
  {
    sentence: "Many argue that climate change is significant.",
    focus: "adjectives",
    correctAnswers: ["significant"],
  },
  {
    sentence: "She attended a seminar on advanced data analysis techniques.",
    focus: "adjectives",
    correctAnswers: ["advanced"],
  },
  {
    sentence: "The scientist meticulously recorded the experiment’s results.",
    focus: "adverbs",
    correctAnswers: ["meticulously"],
  },
  {
    sentence: "The debate highlighted ethical concerns in medicine.",
    focus: "adjectives",
    correctAnswers: ["ethical"],
  },
  {
    sentence: "Researchers propose solutions to address pollution.",
    focus: "verbs",
    correctAnswers: ["propose", "address"],
  },
  {
    sentence: "Globalization has profoundly influenced cultural exchange.",
    focus: "adverbs",
    correctAnswers: ["profoundly"],
  },
  {
    sentence: "The professor delivered a compelling lecture.",
    focus: "adjectives",
    correctAnswers: ["compelling"],
  },
  {
    sentence: "The company rapidly expanded into new markets.",
    focus: "adverbs",
    correctAnswers: ["rapidly"],
  },
  {
    sentence: "Legislation regulates environmental standards.",
    focus: "verbs",
    correctAnswers: ["regulates"],
  },
  {
    sentence: "She offered a detailed explanation during the interview.",
    focus: "adjectives",
    correctAnswers: ["detailed"],
  },
  {
    sentence: "He systematically organized his research materials.",
    focus: "adverbs",
    correctAnswers: ["systematically"],
  },
  {
    sentence: "Scientists observe patterns and formulate hypotheses.",
    focus: "verbs",
    correctAnswers: ["observe", "formulate"],
  },
  {
    sentence: "The team’s innovative strategy yielded positive results.",
    focus: "adjectives",
    correctAnswers: ["innovative", "positive"],
  },
  {
    sentence: "The jury deliberated extensively before reaching a verdict.",
    focus: "adverbs",
    correctAnswers: ["extensively"],
  },
  {
    sentence: "She submitted a revised version of her essay.",
    focus: "adjectives",
    correctAnswers: ["revised"],
  },
  {
    sentence: "The artist interpreted the theme creatively.",
    focus: "adverbs",
    correctAnswers: ["creatively"],
  },
  {
    sentence: "Scientists frequently collaborate across disciplines.",
    focus: "adverbs",
    correctAnswers: ["frequently"],
  },
],

      10: [
  {
    sentence: "Social media platforms profoundly impact communication.",
    focus: "adverbs",
    correctAnswers: ["profoundly"],
  },
  {
    sentence: "Global collaboration is crucial for environmental challenges.",
    focus: "adjectives",
    correctAnswers: ["global", "environmental"],
  },
  {
    sentence: "Economic factors significantly influence geopolitical trends.",
    focus: "adverbs",
    correctAnswers: ["significantly"],
  },
  {
    sentence: "The board unanimously approved the corporate policy.",
    focus: "adverbs",
    correctAnswers: ["unanimously"],
  },
  {
    sentence: "Students constructed elaborate models for the science fair.",
    focus: "adjectives",
    correctAnswers: ["elaborate"],
  },
  {
    sentence: "The research team meticulously analyzed the data.",
    focus: "adverbs",
    correctAnswers: ["meticulously"],
  },
  {
    sentence: "Renewable resources are increasingly valued in modern economies.",
    focus: "adverbs",
    correctAnswers: ["increasingly"],
  },
  {
    sentence: "Her persuasive essay addressed controversial topics.",
    focus: "adjectives",
    correctAnswers: ["persuasive", "controversial"],
  },
  {
    sentence: "The journalist thoroughly investigated the allegations.",
    focus: "adverbs",
    correctAnswers: ["thoroughly"],
  },
  {
    sentence: "Their innovative solution received international recognition.",
    focus: "adjectives",
    correctAnswers: ["innovative", "international"],
  },
  {
    sentence: "Volunteers generously supported the local initiative.",
    focus: "adverbs",
    correctAnswers: ["generously"],
  },
  {
    sentence: "She accurately interpreted the experimental results.",
    focus: "adverbs",
    correctAnswers: ["accurately"],
  },
  {
    sentence: "The government swiftly implemented new regulations.",
    focus: "adverbs",
    correctAnswers: ["swiftly"],
  },
  {
    sentence: "He challenged conventional wisdom during the debate.",
    focus: "adjectives",
    correctAnswers: ["conventional"],
  },
  {
    sentence: "The committee reviewed each application objectively.",
    focus: "adverbs",
    correctAnswers: ["objectively"],
  },
  {
    sentence: "The architect designed an environmentally sustainable building.",
    focus: "adjectives",
    correctAnswers: ["environmentally", "sustainable"],
  },
  {
    sentence: "Policy makers carefully evaluated the economic consequences.",
    focus: "adverbs",
    correctAnswers: ["carefully"],
  },
  {
    sentence: "She presented a coherent argument in her report.",
    focus: "adjectives",
    correctAnswers: ["coherent"],
  },
  {
    sentence: "The results clearly demonstrated the hypothesis.",
    focus: "adverbs",
    correctAnswers: ["clearly"],
  },
  {
    sentence: "Participants collaboratively developed effective strategies.",
    focus: "adverbs",
    correctAnswers: ["collaboratively"],
  },
],

      11: [
  {
    sentence: "Her argument was compelling, backed by substantial evidence.",
    focus: "adjectives",
    correctAnswers: ["compelling", "substantial"],
  },
  {
    sentence: "Entrepreneurs often exhibit resilience in tough markets.",
    focus: "adverbs",
    correctAnswers: ["often"],
  },
  {
    sentence: "Researchers meticulously documented their methodology.",
    focus: "adverbs",
    correctAnswers: ["meticulously"],
  },
  {
    sentence: "He expressed concern regarding the sustainability of practices.",
    focus: "nouns",
    correctAnswers: ["concern", "practices"],
  },
  {
    sentence: "Literary works often reflect socio-political climates.",
    focus: "adverbs",
    correctAnswers: ["often"],
  },
  {
    sentence: "The philosopher proposed a controversial theory.",
    focus: "adjectives",
    correctAnswers: ["controversial"],
  },
  {
    sentence: "Data analysts systematically processed large datasets.",
    focus: "adverbs",
    correctAnswers: ["systematically"],
  },
  {
    sentence: "She synthesized multiple perspectives in her essay.",
    focus: "verbs",
    correctAnswers: ["synthesized"],
  },
  {
    sentence: "The report provided a comprehensive overview of current research.",
    focus: "adjectives",
    correctAnswers: ["comprehensive", "current"],
  },
  {
    sentence: "Economists cautiously predicted a gradual recovery.",
    focus: "adverbs",
    correctAnswers: ["cautiously"],
  },
  {
    sentence: "His analysis highlighted significant discrepancies.",
    focus: "adjectives",
    correctAnswers: ["significant"],
  },
  {
    sentence: "The committee convened to address urgent matters.",
    focus: "adjectives",
    correctAnswers: ["urgent"],
  },
  {
    sentence: "She articulated her vision with remarkable clarity.",
    focus: "adjectives",
    correctAnswers: ["remarkable"],
  },
  {
    sentence: "The scientists collaboratively designed the experiment.",
    focus: "adverbs",
    correctAnswers: ["collaboratively"],
  },
  {
    sentence: "Lawmakers debated policies affecting marginalized groups.",
    focus: "verbs",
    correctAnswers: ["debated", "affecting"],
  },
  {
    sentence: "Their proposal included detailed recommendations.",
    focus: "adjectives",
    correctAnswers: ["detailed"],
  },
  {
    sentence: "The novelist explored existential themes.",
    focus: "verbs",
    correctAnswers: ["explored"],
  },
  {
    sentence: "She delivered her presentation eloquently.",
    focus: "adverbs",
    correctAnswers: ["eloquently"],
  },
  {
    sentence: "The conference attracted international participants.",
    focus: "adjectives",
    correctAnswers: ["international"],
  },
  {
    sentence: "Advancements in technology continuously transform industries.",
    focus: "adverbs",
    correctAnswers: ["continuously"],
  },
],

      12: [
        {
          sentence: "Quantum mechanics provides insight into fundamental reality.",
          focus: "adjectives",
          correctAnswers: ["fundamental"],
        },
        {
          sentence: "She extensively researched philanthropic endeavors.",
          focus: "adverbs",
          correctAnswers: ["extensively"],
        },
        {
          sentence: "Professional integrity demands adherence to ethical standards.",
          focus: "nouns",
          correctAnswers: ["integrity", "standards"],
        },
        {
          sentence: "The committee deliberated extensively before ratifying amendments.",
          focus: "verbs",
          correctAnswers: ["deliberated", "ratifying"],
        },
        {
          sentence: "Emerging technologies continually reshape global economies.",
          focus: "adverbs",
          correctAnswers: ["continually"],
        },
      ],
    };
  
    // Return the array for this grade if it exists, or an empty array otherwise
    return data[grade] || [];
  }
  